module.exports = __webpack_public_path__ + "static/media/a-delete.186c275b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/a-delete.svg
// module id = 1229
// module chunks = 0